import React from 'react'
import PropTypes from 'prop-types'
import Shimmer from 'Components/shimmer'

const MaleDailyArticleCardOneShimmer = ({ isMobile }) => {
  return (
    <>
      <div className="article-style-one-shimmer">
        <div className="article-style-one-shimmer__image">
          <Shimmer
            width={isMobile ? '328px' : '400px'}
            height={isMobile ? '328px' : '400px'}
          />
        </div>
        <div className="article-style-one-shimmer__text">
          <Shimmer width="88px" height="12px" />
          <div className="article-style-one-shimmer__title">
            <Shimmer width="100%" height="12px" />
            <Shimmer width="100%" height="12px" />
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .article-style-one-shimmer {
            display: flex;
            flex-direction: column;
            gap: 12px;
            text-decoration: none;
          }

          .article-style-one-shimmer__text {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .article-style-one-shimmer__title {
            display: flex;
            flex-direction: column;
            width: 100%;
          }
        `}
      </style>
    </>
  )
}

MaleDailyArticleCardOneShimmer.propTypes = {
  isMobile: PropTypes.bool,
}

export default MaleDailyArticleCardOneShimmer
